/**
 * @desc 锁定
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockOrderLockingCmd, options?: any) {
  return updateResponse(
    http(URL + `/stock/locking`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
